import { render, staticRenderFns } from "./CartasTotalesFiltradas.vue?vue&type=template&id=da7128c6&"
import script from "./CartasTotalesFiltradas.vue?vue&type=script&lang=js&"
export * from "./CartasTotalesFiltradas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports